
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/informacje-motoryzacja/data/[rok]/[miesiac]",
      function () {
        return require("private-next-pages/informacje-motoryzacja/data/[rok]/[miesiac].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/informacje-motoryzacja/data/[rok]/[miesiac]"])
      });
    }
  